'use strict';exports.__esModule = true;var fetchPropertyNoteById = function fetchPropertyNoteById(id, notesArray) {
  var propertyNote = notesArray.find(function (item) {return item.id === id;});
  return propertyNote ? propertyNote.note.trim() : '';
};exports.default =

fetchPropertyNoteById;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/fetchPropertyNoteById.js
// module id = 292
// module chunks = 0